import { Link } from "react-router-dom";

interface FooterLink {
  label: string;
  href: string;
  external?: boolean;
}

interface FooterColumn {
  heading: string;
  links: FooterLink[];
}

interface LandingFooterProps {
  extraColumns?: FooterColumn[];
}

const LandingFooter = ({ extraColumns }: LandingFooterProps) => {
  const defaultColumns: FooterColumn[] = [
    {
      heading: "Navigation",
      links: [
        { label: "How It Works", href: "/#how-it-works" },
        { label: "Features", href: "/#features" },
        { label: "Pricing", href: "/pricing" },
      ],
    },
    {
      heading: "Tools",
      links: [
        { label: "Free SEO Audit", href: "/tools/free-seo-audit" },
        { label: "AI Visibility Checker", href: "/tools/ai-visibility-checker" },
      ],
    },
    {
      heading: "Resources",
      links: [
        { label: "Login", href: "/login" },
        { label: "FAQ", href: "/#faq" },
        { label: "Contact", href: "mailto:hello@unrankedagency.com", external: true },
        { label: "Sitemap", href: "/sitemap.xml", external: true },
      ],
    },
  ];

  const allColumns = [...defaultColumns, ...(extraColumns ?? [])];

  return (
    <footer className="border-t border-border py-12">
      <div className="container mx-auto px-6 text-sm text-muted-foreground">
        <div className="grid grid-cols-1 md:grid-cols-[1.5fr_1fr_1fr_1fr] gap-10 md:gap-8">
          {/* Brand block */}
          <div className="flex flex-col items-start gap-2">
            <img
              src="/Unranked-agency-logo.png"
              alt="Unranked Agency"
              className="h-6 w-auto object-contain"
            />
            <span className="text-muted-foreground">
              AI-powered SEO &amp; visibility analysis
            </span>
          </div>

          {/* Link columns */}
          {allColumns.map((col) => (
            <div key={col.heading} className="flex flex-col gap-3">
              <h3 className="text-foreground font-medium uppercase tracking-wide text-xs">
                {col.heading}
              </h3>
              <ul className="flex flex-col gap-2">
                {col.links.map((l) => (
                  <li key={l.href}>
                    {l.external ? (
                      <a
                        href={l.href}
                        className="hover:text-foreground transition-colors"
                      >
                        {l.label}
                      </a>
                    ) : (
                      <Link
                        to={l.href}
                        className="hover:text-foreground transition-colors"
                      >
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-border mt-10 pt-6 text-center">
          © {new Date().getFullYear()} Unranked Agency. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
